import {
	AGENDA_EVENT_GET, ATTENDEE_EVENT_GET, ATTENDEES_EVENT_GET,
	EVENT_GET,
	EVENT_GET_ERROR,
	EVENT_LOADING_STATUS,
	EVENTS_FETCH, EVENTS_FETCH_CATEGORIES, GET_ACTION_LINKS,
	PARTNERS_EVENT_GET, REMOVE_ATTENDEES_EVENT,
	SESSION_EVENT_GET,
	SESSION_EVENT_CLEAR,
	GET_ACTION_FILES,
	SESSION_EVENT_QUESTIONS_GET,
	SESSION_EVENT_QUESTION_UPDATE,
	SESSION_EVENT_QUESTIONS_CLEAR,
	EVENTS_CLEAR,
	EVENT_LOADING_CATEGORIES_STATUS
} from '@/store/event/types'

const initialState = {
	loading: false,
	loadingCategories: false,
	event: {},
	agenda: [],
	errors: [],
	events:[],
	session: null,
	sessionQuestions: null,
	partners:[],
	attendees: [],
	attendee: null,
	categories: [],
	categoriesMeta: null,
	actionFiles: [],
	actionLinks: [],

	actionLinksMeta: null,
	actionFilesMeta: null,
	sessionQuestionsMeta: null,

	pageCount: {
		events: 0,
		agendas: 0,
		partners: 0,
		attendees: 0,
	},
	totalCount: {
		attendees: 0
	}
}

export const state = { ...initialState }

export default {
	[EVENT_LOADING_STATUS]: (state, status) => {
		state.loading = status
	},

	[EVENTS_FETCH]: (state, payload) => {
		state.event = initialState.post
		state.events = [...payload.data]
		state.pageCount.events = +payload.pageCount
	},

	[EVENTS_FETCH_CATEGORIES]: (state, payload) => {
		const {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage
		} = payload
		state.categories = [...state.categories, ...data]
		state.categoriesMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage
		}
	},

	[GET_ACTION_LINKS]: (state, payload) => {
		const {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage
		} = payload

		state.actionLinks = data
		state.actionLinksMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage
		}
	},

	[GET_ACTION_FILES]: (state, payload) => {
		const {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage
		} = payload

		state.actionFiles = data
		state.actionFilesMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage
		}
	},

	[EVENT_GET]: (state, payload) => {
		state.event = payload
		state.agenda = initialState.agenda
	},

	[REMOVE_ATTENDEES_EVENT]: (state) => {
		state.attendees = []
	},

	[AGENDA_EVENT_GET]: (state, payload) => {
		state.agenda = [...payload.data]
		state.pageCount.agendas = +payload.pageCount
	},

	[SESSION_EVENT_GET]: (state, payload) => {
		state.session = payload
	},

	[SESSION_EVENT_CLEAR]: (state) => {
		state.session = null
	},

	[ATTENDEES_EVENT_GET]: (state, payload) => {
		state.attendees = [...payload.data]
		state.pageCount.attendees = +payload.pageCount
		state.totalCount.attendees = +payload.totalCount
	},

	[ATTENDEE_EVENT_GET]: (state, payload) => {
		state.attendee = payload
	},

	[PARTNERS_EVENT_GET]: (state, payload) => {
		state.partners = [...payload.data]
		state.pageCount.partners = +payload.pageCount
	},

	[EVENT_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[SESSION_EVENT_QUESTIONS_GET]: (state, payload) => {
		const {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage
		} = payload
		state.sessionQuestions = data
		state.sessionQuestionsMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage
		}
	},

	[SESSION_EVENT_QUESTIONS_CLEAR]: (state) => {
		state.sessionQuestions = null;
		state.sessionQuestionsMeta = null;
	},

	[SESSION_EVENT_QUESTION_UPDATE]: (state, payload) => {
		state.sessionQuestions = state.sessionQuestions.map(question => {
			if (question.session_question_answer_id === payload.answerId) {
				return {
					...question,
					upvote: payload.status,
					session_question_count: payload.status ? question.session_question_count + 1 : question.session_question_count - 1
				}
			} else {
				return question
			}
		})
	},

	[EVENTS_CLEAR]: (state) => {
		state.categories = []
		state.categoriesMeta = null
	},

	[EVENT_LOADING_CATEGORIES_STATUS]: (state, payload) => {
		state.loadingCategories = payload
	}
}
